//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import {mapState} from 'vuex'
  import Api from '../../utils/config'
  import { cancelOrder } from '../../service/index'
  export default {
    data () {
      return {
        dialogVisible: false
      }
    },
    props: {
      orderId: Number,
      tableData: Array,
      orderDate: Number,
      status: Number,
      amount: Number,
      payAmount: Number,
      orderNo: String,
      cancel: Function,
      info: Object
    },
    async beforeMount () {},
    mounted () {},
    components: {},
    computed: {
      ...mapState(['global','specName','specNameEn']),
      specNames(){
         return  this.$i18n.locale  === 'en' ? this.specNameEn : this.specName;
      },
      totalQty(){
        let qty = 0
        this.tableData.map(item => {
          qty += item.qty;
        })
        return qty;
      }
    },
    methods: {
      queryOrderDetail (orderId) {
        this.$router.push({path: '/orderDetail/' + orderId, query:{cid: this.$route.query.cid}})
      },
      async cancelThisOrder () {
        // 取消订单
        // 没有取消订单的接口
        const res = await cancelOrder(this.orderId)
        if(res.status === 0){
          this.cancel(this.info)
          this.$message({
            message: this.$t('order.cancelSuccess'),
            type: 'success'
          })
        }else{
          this.$message({
            message: this.$t('order.cancelFailed'),
            type: 'error'
          })
        }
        this.dialogVisible = false
      },
      payMoney () {
        window.location = Api.payment + this.orderId;
      },
      exportDetail (orderId){
        window.location.href = "/is/store/order/exportDetail/" + orderId;
      }
    },
    watch: {}
  }



// WEBPACK FOOTER //
// ./src/components/order/Order.vue